import Vue from "vue"
import {
  toQueryString,
  getQueryParams,
  queryStringToObject,
  getSubQueryString,
  getSubQueryParams,
  clearQuery,
  clearSubQuery,
  updateSubQuery,
  updateQuery,
  allowKeypress,
  getFormattedDatesDiff,
  toTitleCase,
  isEqualQueryString,
} from "@evercam/shared/utils"

if (!Vue.__shared_mixin___) {
  // See https://nuxtjs.org/docs/directory-structure/plugins/#global-mixins
  Vue.__shared_mixin___ = true

  Vue.mixin({
    methods: {
      getFormattedDatesDiff,
      allowKeypress,
      updatePageURL(queryString, defaultParamsString, forceUpdate = false) {
        const path = this.$route.path
        const query = this.queryStringToObject(queryString)
        const cleanedQueryString = this.toQueryString(query)
        const subQuery = this.getSubQueryString()
        const isDefault = isEqualQueryString(
          cleanedQueryString,
          defaultParamsString
        )

        const finalQuery =
          isDefault && !forceUpdate
            ? {}
            : this.queryStringToObject(cleanedQueryString)

        this.$router
          .replace({ path, query: finalQuery, hash: subQuery || undefined })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              throw err
            }
          })
      },
      toQueryString: (params) =>
        toQueryString(params, { forceSnakeCase: false }),
      queryStringToObject: (queryString) => queryStringToObject(queryString),
      getQueryParams,
      getSubQueryString,
      getSubQueryParams,
      updateQuery: (queryObj = {}) => updateQuery(queryObj),
      updateSubQuery: (params = { subQueryObj: {} }) => updateSubQuery(params),
      clearQuery,
      clearSubQuery,
      toTitleCase,
      formatDate(date, format = "DD MMM YYYY HH:mm:ss") {
        return this.$moment(date).isValid()
          ? this.$moment(date).format(format)
          : "-"
      },
      relativeDate(date) {
        return this.$moment(date).isValid() ? this.$moment(date).fromNow() : "-"
      },
    },
  })
}
